// Backend add-to-cart errors (Dtf::AddToCart#errors_formatted) come back as a
// flat object whose values are user-facing strings, plus a `success: false`
// flag. Known keys include:
//   error_message                    — generic 5xx fallback
//   <artwork_id>                     — per-artwork validation (e.g. MOQ, dims, "Invalid variant ID")
//   missing_artwork_attachment       — named upload errors
//   missing_spangle_pages_info
//   artwork_attachments
//   spangle_pages_info
// Surface the first usable string so the user sees an actionable message
// instead of the generic "Items were not added" default. error_message takes
// priority; otherwise, the first non-`success` string-valued entry wins.
// Returns undefined when no string is found, so the caller can leave the
// modal's static default in place.
//
// Note: callers MUST render the returned string with .text(), not .html() —
// per-artwork strings interpolate user-controlled values (variant_id, etc.)
// from the request payload.
export const extractAddToCartErrorMessage = (errorResponse: unknown): string | undefined => {
  if (!errorResponse || typeof errorResponse !== "object") return undefined;

  const response = errorResponse as Record<string, unknown>;
  const topLevel = response["error_message"];
  if (typeof topLevel === "string" && topLevel) return topLevel;

  const artworkEntry = Object.entries(response).find(
    ([key, value]) => key !== "success" && typeof value === "string" && value
  );
  return artworkEntry?.[1] as string | undefined;
};
